
let testView
testView = 'both'
// testView = 'togo'
// testView = 'food'
// testView = 'drinks'

let testMenuBoard
testMenuBoard = 'left'
// testMenuBoard = 'right'

let testLoc
// testLoc = 'none'
testLoc = 'dauphine'
// testLoc = 'maple'


let locIdLookup = {
  none : -1,
  dauphine : 55,
  maple : 204
}

let menuBoardIdLookup = {
  none : -1,
  dauphine : {
    left : 250,
    right : 267
  },
  maple : {
    left : 280,
    right : 279
  }
}

let menuIdLookup = {
  both : [48, 38,45],
  togo : [48, 38,45],
  food : [38,45], // dauphine right (Food)
  drinks : [48], // dauphine left (Drinks)
}

module.exports = {
  rest_url : 'http://satsumawp.test/wp-json',
  wp_login_url : 'http://satsumawp.test/wp-login.php?redirect_to=http%3A%2F%2Fsatsumawp.test%2Flocations%2Fdauphine-street%2F',
  authToken : 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC9zYXRzdW1hd3AudGVzdCIsImlhdCI6MTUzNjgxNDAwNiwibmJmIjoxNTM2ODE0MDA2LCJleHAiOjEwMTc2ODE0MDA2LCJkYXRhIjp7InVzZXIiOnsiaWQiOiIxIn19fQ.KMR3aHet90VOTnnZfvoPeD4ob3apf9hac4mrMX1zo20',
  user : {
    logged_in : true
  },

  print: 1,
  togo:0,
  menu_ids : menuIdLookup[ testView ],
  location : -1,
  // location : locIdLookup[ testLoc ],
  menu_board_id : menuBoardIdLookup[ testLoc ][ testMenuBoard ],

  // location : [204,'55'], // both locations
  // single location
  // location : '55', // Dauphine st
  // menu_ids : [48, 38, 45],

  // Menu Board (Maple - Left)
  // location : "-1",
  // menu_board_id : "280",
  // menu_ids : [278,277],

  // Menu Board (Maple - Right)
  // location : "-1",
  // menu_board_id : 279,
  // menu_ids : [273],

  // Menu Board (Dauphine - Left)
  // location : "-1",
  // menu_board_id : 250,
  // menu_ids : [48],

  // Menu Board (Dauphine - Right)
  // location : "-1",
  // menu_board_id : 267,
  // menu_ids : [38,45],
  
  // Menu Board (Both Menus)
  // location : "-1",
  // menu_ids : [38,45], // dauphine right (Food)
  // menu_ids : [48], // dauphine left (Drinks)
  // menu_ids : [48,  38,45], // both (togo)

  cpts : {
    locations : 'satsuma_locations',
    menus : 'satsuma_menus',
    menuBlocks : 'satsuma_menu_blocks'
  },
  pdfData : {
    clientId : 'testing',
    location : 'Maple',
    menuName : 'Food',
    purpose: 'Menu Board',
    // customName : 'Spring 2018', // Conditional
    targetURL : 'http://staging.satsumacafe.com/menus/dauphine-left',
    timeZone: -7,
    puppeteerConfig : null    
  }
}



// WEBPACK FOOTER //
// ./src/components/testWpData.js